import { getCookie } from '@/helpers/cookieMetods';
import type { EntityId } from '../types/common';
import type { NewsPost } from '../types/news';
import { JSON_POST_HEADERS } from './constants';
import { domain, parseJsonOrThrow } from './http';

export const createNewHolidayDate = ({
  title,
  date,
  cat_id,
  autor_id,
}: {
  title: string;
  date: string;
  cat_id: EntityId;
  autor_id: EntityId | undefined;
}): Promise<Response> => {
  const token = getCookie('_form_token');
  const data = new FormData();
  data.append('token', `${token}`);
  data.append('title', title);
  data.append('pub_date', date);
  data.append('cat_id', String(cat_id));
  data.append('autor_id', String(autor_id));
  return fetch(`${domain}/php/newsadd.php`, { method: 'POST', body: data });
};

export const updateHolidayPost = ({
  title,
  date,
  cat_id,
  autor_id,
  id,
}: {
  title: string;
  date: string;
  cat_id: EntityId;
  autor_id: EntityId | undefined;
  id: EntityId;
}): Promise<Response> => {
  const token = getCookie('_form_token');
  const data = new FormData();
  data.append('id', String(id));
  data.append('token', `${token}`);
  data.append('title', title);
  data.append('pub_date', date);
  data.append('cat_id', String(cat_id));
  data.append('autor_id', String(autor_id ?? ''));
  return fetch(`${domain}/php/newsadd.php`, { method: 'POST', body: data });
};

export const getHolidayFromID = (
  postID: EntityId,
  categoryID: EntityId,
  debug = 0
): Promise<unknown> => {
  const token = getCookie('_form_token');
  return fetch(`${domain}/php/newsout.php`, {
    method: 'POST',
    headers: JSON_POST_HEADERS,
    body: JSON.stringify({
      id: postID,
      categoryID,
      token,
      debug,
    }),
  }).then((response) => parseJsonOrThrow<unknown>(response));
};

/** Single holiday post for `id`, or `null` when the API returns an empty list. */
export const getHolidayById = (
  postID: EntityId,
  categoryID: EntityId,
  debug = 0
): Promise<NewsPost | null> =>
  getHolidayFromID(postID, categoryID, debug).then(
    (result) => (result as NewsPost[])?.[0] ?? null
  );
